import { configureStore } from '@reduxjs/toolkit';
import Reducers from './reducers/Reducers';

const Store = configureStore({
  reducer: Reducers,
});

export default Store;
